import { makeStyles } from "@material-ui/styles";

export const useStoreStyles: any = makeStyles(
  (theme: { [key: string]: any }) => ({
    companyTitle: {
      fontWeight: "bold",
      fontSize: "3em",
      paddingLeft: "2em",
    },
    mainGridStyle: {
      paddingTop: "2em",
    },
    valueStyles: {
      fontSize: "19px",
    },
    textStyles: {
      fontSize: "19px",
      fontWeight: "bold",
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: "center",
      backgroundColor: "#dcdcdc",
    },
  })
);
